export default "__VITE_ASSET__BID9m6XN__"